import styles from "../style/style.module.css";
import DancingLetters from "./dancingLetters";
import Button from "./button";

const EndingBanner = ({ buttonText }) => {
  let image = styles.endingBanner;

  return (
    <section className={`${image} relative`}>
      <div className="flex w-full flex-col items-center justify-center gap-6 px-[5vw] py-16">
        <h1 className="text-1xl text-center font-semibold text-white md:text-3xl">
          <DancingLetters title={"Need Further Information!"} />
        </h1>
        <p className="text-center text-base font-light text-white md:text-22 lg:px-[20vw]">
          We have a team of experts and domain knowledge professionals, who can
          help you in your projects.
        </p>

        <Button href="/contactus">
          <span className="px-10">Contact Now</span>
        </Button>
      </div>
    </section>
  );
};

export default EndingBanner;
